import { createApp } from 'vue'
import App from './App.vue'
import setupI18n from './i18n'; // 导入异步 i18n 设置函数
import router from './router';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 异步初始化应用
(async () => {
const app = createApp(App)
const i18n = await setupI18n(); // 等待 i18n 初始化完成

app.use(router);
app.use(ElementPlus)
app.use(i18n);
app.mount('#app')
})();

